import HomePage from "../../Home/HomePage";
import GroundZeroList from "../../PlayGround/Pages/GroundZeroList";
import ConsoleMethods from "../../PlayGround/Pages/JsBasics/ConsoleMethods";
import LdArrays from "../../PlayGround/Pages/Lodash/LdArrays";
import ReactFormHook from "../../PlayGround/Pages/ReactFormHook/ReactFormHook";
import ResetPassFormHook from "../../PlayGround/Pages/ReactFormHook/ResetPassFormHook";
import PlayGroundIndex from "../../PlayGround/PlayGroundIndex";
import TestIndex from "../../PlayGround/tests/TestIndex";
import ImageSharePage from "../Pages/ImageSharePage";
import NotFoundPage from "../Pages/NotFoundPage";

export const MainRouteMapper = [
    {
        path: "/",
        element: <HomePage />,

    },
    {
        path: "/shd-image-share",
        element: <ImageSharePage />,
    },
    {
        path: "/nkc-img-share",
        element: <ImageSharePage />,
    },
    {
        path: "/play",
        element: <PlayGroundIndex />,
        children: [
            { path: "", element: <GroundZeroList /> },
            { path: "react-form-hook", element: <ReactFormHook /> },
            { path: "react-form-hook/reset-password-form", element: <ResetPassFormHook /> },
            { path: "js-console-methods-and-usage", element: <ConsoleMethods /> },
            { path: "/play/lodash-array-methods", element: <LdArrays /> },

        ],
    },
    {
        path: "/test",
        element: <TestIndex />,
        // children: [
        //     { path: "", element: <GroundZeroList /> },
        //     { path: "react-form-hook", element: <ReactFormHook /> },
        //     { path: "react-form-hook/reset-password-form", element: <ResetPassFormHook /> },
        //     { path: "js-console-methods-and-usage", element: <ConsoleMethods /> },

        // ],
    },
    {
        path: "*",
        element: <NotFoundPage />,
    },
]